/**
 * Admin allowlist — only these emails can access /admin/*.
 *
 * Update here to add/remove admins — no DB migration needed.
 * Keep this list short; admins can see all users, datasets, and revenue data.
 */
export const ADMIN_EMAILS: ReadonlyArray<string> = [
  "damianforzani@gmail.com",
]

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false
  return ADMIN_EMAILS.includes(email.toLowerCase())
}

// Re-export plan pricing from the single source of truth.
// Kept here as a named export so existing imports in the admin page don't break.
export { PLAN_PRICES_MONTHLY } from "@/lib/plans"
